import Layout from '../views/layout/App.vue'
export default {
  path: '/notice_manage',
  name: 'noticeManage',
  meta: {
    title: '通知管理',
    keepAlive: false
  },
  component: Layout,
  redirect: '/notice_manage/notice_list',
  children: [
    {
      path: 'notice_list',
      name: 'noticeList',
      meta: {
        title: '通知列表',
        keepAlive: true
      },
      component: resolve => require(['@/views/noticeManage/noticeList/Index.vue'], resolve),
    },
  ]
}
